// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientSummaryPharmacy {
    static getAttributeTypeMap() {
        return MangoHubGetPatientSummaryPharmacy.attributeTypeMap;
    }
}
MangoHubGetPatientSummaryPharmacy.discriminator = undefined;
MangoHubGetPatientSummaryPharmacy.attributeTypeMap = [
    {
        "name": "pharmacyName",
        "baseName": "pharmacyName",
        "type": "string"
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    }
];
//# sourceMappingURL=mangoHubGetPatientSummaryPharmacy.js.map